import React from 'react';
import css from './WhereIsMyVin.module.scss';
import { strings } from 'src/localization';
import { Dialog } from '@framework-controls/core';
import { IconRemove } from 'src/content/icons';
import SVPButton from '../SVPButtons/SVPButton';
import VinLocation from 'src/content/images/VinLocation.jpg';
import classNames from 'classnames';

export interface IProps {
    whereHandler: (e: any) => void;
    whereOpen: boolean;
    theme?: string;
}

const WhereIsMyVin = (props: IProps) => {
    const headerBoxStyles = classNames(
        css.headerbox,
        {
            [css.headerboxMazda]: props.theme === 'mazda',
            [css.headerboxGenesis]: props.theme === 'genesis',
        },
    );

    const dialog = <Dialog
        cssClasses={{
            content: css.content,
            paper: css.paper,
            header: css.LightBoxHeader,
        }}
        // Override the openFlag with the props openFlag if defined
        isOpen={props.whereOpen}
        anchorOrigin={{
            vertical: 'top',
        }}
        header={strings.WhereVinHeader}
        hideSave={true}
        hideCancel={true}
        disableUpperCase={true}
        onCancel={props.whereHandler}
        onBackDropClick={props.whereHandler}
        width={'full'}
    >
        <div className={headerBoxStyles}>
            {strings.WhereVinHeader}
            <div className={css.headerIcon}>
                <IconRemove id='closeBtn' onClick={props.whereHandler}/>
            </div>
        </div>
        <div>
            <div>
                <div className={css.typicalVin}>{strings.TypicalVINLoc}</div>
                <img
                    src={VinLocation}
                    alt={''}
                    className={css.VinLocation}
                />
            </div>
            <div className={css.otherVinLoc}>{strings.OtherVinLoc}</div>
            <ul className={css.otherVinLoc}>
                <li>{strings.InsuranceIdCard}</li>
                <li>{strings.VehRegCard}</li>
            </ul>
        </div>
        <div className={css.btnArea}>
            <SVPButton
                id='Cancel'
                handler={props.whereHandler}
                message={strings.Close}
                variant={'primaryBtnAlt'}
                noArrow
                theme={props.theme}/>
        </div>
    </Dialog>;

    return (
        <div>
            {dialog}
        </div>
    );
};

export default WhereIsMyVin;